import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {RootState} from "@/app/store";
import {API_ACCOUNT} from "@/app/_api/types/account";
import {UserGlobalInfo} from "@/Core/Login/types/user";

export interface AccountInfoState {
    info: {
        userVipExp: number,
        userVipName: string,
        userNextVipExp: number,
        vipConfigList: API_ACCOUNT.VipConfigListResponse,
    },
    responseStatus: 'finish' | 'loading' | 'failed'
}

const initialState: AccountInfoState = {
    info: {
        userVipExp: 0,
        userVipName: '',
        userNextVipExp: 0,
        vipConfigList: {
            vipLevels: [],
            vipBenefits: []
        },
    },
    responseStatus: 'finish',
}

export const updateAccountAsync = createAsyncThunk(
    'counter/fetchCount',
    async (user: UserGlobalInfo) => {

        const {vipExp} = user.baseInfo

        const mergeData:AccountInfoState['info'] = {
            userVipExp: 0,
            userNextVipExp: 0,
            userVipName: '',
            vipConfigList: {
                vipLevels: [],
                vipBenefits: []
            }
        }

        // const response = await $http.Account.vipConfigList();
        // const { vipLevels } = response;
        //
        // // 根据用户当前vip等级获取用户vip等级名称
        // const userVipLevel = vipLevels.find((item: any) => item.vipLevel === user.baseInfo.vipLevel);
        // mergeData.userVipName = userVipLevel?.levelName || "";
        //
        // // 根据用户当前vip等级获取用户下一个vip等级所需经验
        // const userNextVipLevel = vipLevels.find((item: any) => item.vipLevel === user.baseInfo.vipLevel + 1);
        // mergeData.userNextVipExp = userNextVipLevel?.reqExperience || 0;
        //
        // // 用户当前vip经验
        // mergeData.userVipExp = vipExp;
        //
        // // 客户端vip等级配置列表
        // mergeData.vipConfigList = response;

        return mergeData;

        // const response = await fetchCount(amount)
        // // The value we return becomes the `fulfilled` action payload
        // return response.data
    }
)

export const AccountInfoSlice = createSlice({
    name: 'accountInfo',
    initialState,
    reducers: {
        updateAccountInfo: (state, action) => {
            state.info = action.payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(updateAccountAsync.pending, state => {
                state.responseStatus = 'loading'
            })
            .addCase(updateAccountAsync.fulfilled, state => {
                state.responseStatus = 'finish'
            })
            .addCase(updateAccountAsync.rejected, state => {
                state.responseStatus = 'failed'
            })
    }
})

export const { updateAccountInfo } = AccountInfoSlice.actions;

export const selectAccountInfo = (state: RootState) => state.accountInfo;

export default AccountInfoSlice.reducer;
